import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';

@Component({
    selector: 'app-contract-report',
    templateUrl: './contract-report.component.html',
    styleUrls: ['./contract-report.component.scss']
})
export class ContractReportComponent implements OnInit {
  @Input() public column : Array<{}> = [];
  @Input() public contractReport : Array<object> = [];
  @Input() public totalRecords: number;
  @Output() public eventVal: EventEmitter<LazyLoadEvent> = new EventEmitter<LazyLoadEvent>();
  public constructor() { }

  public ngOnInit(): void {}
  public onLazyLoad(event:LazyLoadEvent) : void {
      this.eventVal.emit(event);
  }
}
